/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiList = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 2a8 8 0 0 1 7.936 7H22v2h-2.063a8.107 8.107 0 0 1-.046.318l-.014.079a8.009 8.009 0 0 1-.3 1.17c-.01.029-.019.059-.03.088a7.65 7.65 0 0 1-.299.73l-.019.044-.002-.001c-.19.4-.41.784-.662 1.144l-1.64-1.144a5.982 5.982 0 0 0 .834-1.745l.012-.04c.026-.092.05-.186.073-.28l.02-.095A6.011 6.011 0 0 0 18 10a6 6 0 0 0-12 0c0 3.034 2.247 5.596 5.142 6.01L11 18H7.5c-.846 0-1.746.35-2.43.933A3.227 3.227 0 0 0 4.233 20H11v2H2v-1c0-1.464.757-2.723 1.772-3.589a5.96 5.96 0 0 1 2.95-1.353A8.125 8.125 0 0 1 4.064 11H2V9h2.064A8 8 0 0 1 12 2z" />
        <path d="M15 22h-2v-2h2zm7 0h-5v-2h5zm-7-4h-2v-2h2zm7 0h-5v-2h5zm-12-6H8V8h2zm6 0h-2V8h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgAiList as AiList };
